/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class Content extends React.Component {
	constructor(props) {
		super(props);

		this.contentMain = React.createRef();

	}

	// componentDidUpdate(prevProps, prevState) {
	// 	if (prevProps && !prevProps.modal && this.props.modal) {
	// 		this.props.addModal(this.props.modal);
	// 	}
	// }

	render() {
		let HeaderContent = null,
			MainContent = this.props.main ? this.props.main : null,
			Modal = this.props.modal ? this.props.modal : null,
			headerClass = classnames('content-header', this.props.headerClass),
			contentClass = classnames(' app-column content main', this.props.contentClass);

		if (MainContent === null && this.props.children) {
			MainContent = this.props.children;
		}

		if (this.props.header !== null) {
			let {header, headerClass, main, contentClass, ...otherProps} = this.props;
			HeaderContent = React.cloneElement(this.props.header, {
				...otherProps,
				contentref: this.contentMain
			});
		}

		return(
			<div ref={this.contentMain} className={contentClass}>
				<div className={headerClass}>
					{HeaderContent}
				</div>
				<main className="content-container">
					{MainContent}
				</main>
				{Modal}
			</div>
		);
	}
};

Content.displayName = "Content";

Content.propTypes = {
	header: PropTypes.element,
	headerClass: PropTypes.string,
	contentClass: PropTypes.string,
	main: PropTypes.element,
};

Content.defaultProps = {
	header: null,
	headerClass: '',
	contentClass: '',
	main: null,
};

export default Content;
